import { QueryClient } from '@tanstack/react-query';
/**
 * Important reads:
 *  - https://tanstack.com/query/latest/docs/framework/react/guides/important-defaults
 *  - https://tanstack.com/query/latest/docs/framework/react/guides/caching
 *
 * By default, React Query assumes the cached data is immediately stale, but the defaut garbage collection is 5 minutes.
 * When useQuery mounts, it reads the data from the cache (so the UI shows up instantly) but then immediately triggers a
 * background refetch to validate the data against the server.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
        },
    },
});
// For debugging with dev tools: https://tanstack.com/query/v5/docs/framework/react/devtools
window.__TANSTACK_QUERY_CLIENT__ = queryClient;
